require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-2018-06-15-rooter-contest-rules.json") })
        }
      }, "path---blog-2018-06-15-rooter-contest-rules");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-2018-06-15-rooter-contest-rules!./.cache/json/blog-2018-06-15-rooter-contest-rules.json
// module id = 334
// module chunks = 231608221292675